module.exports = __webpack_public_path__ + "static/img/10areaB_07.5c2e50d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_07.png
// module id = 1077
// module chunks = 1